import { findArray, filterArray } from 'helpers/utils';
import { isFinishedStatus } from "helpers/status";
import { getIsMixed } from 'components/sports/tri/helper/TriHelpers';


export const getConfigData = (discipline, data, rsc) => {
    switch (discipline) {
        case "ATH":
            return getConfigATH(data);
        case "TRI":
            return getConfigTRI(data, rsc);
        case "OWS":
            return getConfigOWS(data);
        case "SWM":
            return getConfigSWM(data);
        case "MPN":
            return getConfigMPN(data, rsc)
        default:
            return getConfigDefault(data)
    }
}

export const mergeCurrentExtendedResults = (discipline, items) => {
    if (!items) return;
    switch (discipline) {
        case "SJP":
        case "CSL":
            return mergeCurrentExtendedResultsCSL(items);
        default:
            return mergeCurrentExtendedResultsDefault(items);
    }
}

const mergeCurrentExtendedResultsCSL = (items) => {
    items.map(item => {
        if (!item?.extendedResults && item?.extendedResultsCurrent) {
            item.extendedResults = item.extendedResultsCurrent
        }
    })
}
const mergeCurrentExtendedResultsDefault = (items) => { }

const getConfigDefault = (data, filters) => {
    let filtersDefault = {
        ei_type: ['LEADER'],
        ei_code: ['CURRENT']
    };
    let _filters = filters ? filters : filtersDefault
    const extendedInfos = data?.results?.extendedInfos
    const items = data?.results?.items
    // filtering extended config where @code='INTERMEDIATE'
    // sorting extended config by @pos using a trick to put 'S' on first position and 'F' on last postition

    //getting final split number. Needed to translate "F" to a number
    let finalPosition = parseInt(data?.config?.extendedConfig?.find(item => item.type === 'EC' && item.code === 'INTERMEDIATES_NUM')?.value);

    //If not starter node added
    // { "type": "EC", "code": "INTERMEDIATE", "value": "1.2", "pos": "1", "extension": [{ "code": "TYPE", "value": "SL" }] }
    if (!data?.config?.extendedConfig?.find(item => item.code === 'INTERMEDIATE' && item.pos === 'S')) {
        //finalPosition = finalPosition + 1
        data?.config?.extendedConfig.push({ "type": "EC", "code": "INTERMEDIATE", "value": "0", "pos": "S", "extension": [{ "code": "DESC", "value": "Start" }] })
    }
    const intermediates =
        data?.config?.extendedConfig?.filter(item => item.code === 'INTERMEDIATE')
            ?.sort((a, b) => (a.pos === 'S' ? 0 : a.pos === 'F' ? finalPosition : a.pos) - (b.pos === 'S' ? 0 : b.pos === 'F' ? finalPosition : b.pos));

    // find leader's current intermediate
    let currentPosition = findArray(extendedInfos, _filters)?.ei_pos
    currentPosition = currentPosition === undefined ? '-1' : currentPosition;
    currentPosition = currentPosition === 'F' ? finalPosition : currentPosition === 'S' ? -1 : parseInt(currentPosition)

    //not have currentPosistion case MTT CRD get from first item his current position 
    currentPosition = currentPosition === -1 ? items?.sort((a, b) => a.sortOrder - b.sortOrder)?.find(x => x !== undefined)?.extendedResults?.find(item => item.er_type === 'ER' && item.er_code === 'CURRENT')?.er_value : currentPosition;
    currentPosition = currentPosition === undefined ? '-1' : currentPosition;

    //competitors who have passed an intermediate point
    const passed = data?.results?.extendedInfos?.filter(item => item.ei_code === 'AFTER_INT' && item.ei_type === 'DISPLAY')?.sort((a, b) => (0 + a.pos === 'S' ? '0' : a.pos === 'F' ? '1000' : a.pos) - (0 + b.pos === 'S' ? '0' : b.pos === 'F' ? '1000' : b.pos));
    //starters
    const starters = findArray(extendedInfos, { ei_type: ['UI'], ei_code: ['STARTERS'] })?.ei_value
    return {
        currentPosition: currentPosition ? currentPosition : null,
        finalPosition: finalPosition ? finalPosition : null,
        intermediates: intermediates ? intermediates : [],
        passed: passed ? passed : null,
        starters: starters ? starters : null,
    }


}

const getConfigSWM = (data) => {
    const extendedInfos = data?.results?.extendedInfos
    const items = data?.results?.items
    // filtering extended config where @code='INTERMEDIATE'
    // sorting extended config by @pos using a trick to put 'S' on first position and 'F' on last postition

    //getting final split number. Needed to translate "F" to a number
    let finalPosition = parseInt(data?.config?.extendedConfig?.find(item => item.type === 'EC' && item.code === 'INTERMEDIATES_NUM')?.value);

    //If not starter node added
    // { "type": "EC", "code": "INTERMEDIATE", "value": "1.2", "pos": "1", "extension": [{ "code": "TYPE", "value": "SL" }] }
    if (!data?.config?.extendedConfig?.find(item => item.code === 'INTERMEDIATE' && item.pos === 'S')) {
        //finalPosition = finalPosition + 1
        data?.config?.extendedConfig.push({ "type": "EC", "code": "INTERMEDIATE", "value": "0", "pos": "S", "extension": [{ "code": "DESC", "value": "Start" }] })
    }
    const intermediates =
        data?.config?.extendedConfig?.filter(item => item.code === 'INTERMEDIATE')
            ?.sort((a, b) => (a.pos === 'S' ? 0 : a.pos === 'F' ? finalPosition : a.pos) - (b.pos === 'S' ? 0 : b.pos === 'F' ? finalPosition : b.pos));

    // find leader's current intermediate
    let currentPosition = extendedInfos?.filter(item => item?.ei_type === 'DISPLAY' && item?.ei_code === 'LEADER')?.pop()?.ei_pos;
    if(extendedInfos?.filter(item => item?.ei_type === 'DISPLAY' && item?.ei_code === 'INT_F')?.pop()) currentPosition='F' //only the finish comes from code: 'INT_F' not code:'LEADER'
    currentPosition = currentPosition === undefined ? '-1' : currentPosition;
    currentPosition = currentPosition === 'F' ? finalPosition : currentPosition === 'S' ? -1 : parseInt(currentPosition)

    //not have currentPosistion case MTT CRD get from first item his current position 
    currentPosition = currentPosition === -1 ? items?.sort((a, b) => a.sortOrder - b.sortOrder)?.find(x => x !== undefined)?.extendedResults?.find(item => item.er_type === 'ER' && item.er_code === 'CURRENT')?.er_value : currentPosition;
    currentPosition = currentPosition === undefined ? '-1' : currentPosition;

    //competitors who have passed an intermediate point
    const passed = data?.results?.extendedInfos?.filter(item => item.ei_code === 'AFTER_INT' && item.ei_type === 'DISPLAY')?.sort((a, b) => (0 + a.pos === 'S' ? '0' : a.pos === 'F' ? '1000' : a.pos) - (0 + b.pos === 'S' ? '0' : b.pos === 'F' ? '1000' : b.pos));
    //starters
    const starters = findArray(extendedInfos, { ei_type: ['UI'], ei_code: ['STARTERS'] })?.ei_value
    return {
        currentPosition: currentPosition ? currentPosition : null,
        finalPosition: finalPosition ? finalPosition : null,
        intermediates: intermediates ? intermediates : [],
        passed: passed ? passed : null,
        starters: starters ? starters : null,
    }


}

const getConfigATH = (data) => {
    const extendedInfos = data?.results?.extendedInfos
    let currentPosition = findArray(extendedInfos, { ei_type: ['DISPLAY'], ei_code: ['INTERMEDIATE_CURRENT'] })?.ei_value
    let finalPosition = findArray(extendedInfos, { ei_type: ['UI'], ei_code: ['INTERMEDIATES_TOTAL'] })?.ei_value
    let lastIntermediate
    // si no esta la configuracion de numero de intermediates tomamos el mayor valor de intermediate
    let lastIntermediateArray = data?.results?.extendedInfos?.filter(item => item?.ei_code === "INTERMEDIATE");
    if (Array.isArray(lastIntermediateArray)) {
        lastIntermediate = Math.max.apply(Math, lastIntermediateArray.map(function (item) {
            return Number(item?.ei_pos);
        }));
    }
    finalPosition = finalPosition ? finalPosition : lastIntermediate


    let intermediates = [];
    let extendedInfosIntermediates = filterArray(extendedInfos, { ei_code: ['INTERMEDIATE'] })
    let ArrayIntermediates = extendedInfosIntermediates && extendedInfosIntermediates?.sort((a, b) => (a.ei_pos === 'F' ? finalPosition : a.ei_pos) - (b.ei_pos === 'F' ? finalPosition : b.ei_pos));
    if (Array.isArray(ArrayIntermediates)) {
        ArrayIntermediates.forEach((item, index) => {
            let labelExchange = item?.extensions?.find(inter => inter?.eie_code === 'EXCHANGE')?.eie_value
            index = index + 1;
            intermediates.push({
                position: index,
                data: {
                    value: item?.ei_value ? item?.ei_value : null,
                    pos: item?.ei_pos ? item?.ei_pos : null,
                    exchange: labelExchange,
                }
            })
        })
    }
    currentPosition = currentPosition === 'F' ? finalPosition : currentPosition
    return {
        currentPosition: currentPosition ? currentPosition : null,
        finalPosition: finalPosition ? finalPosition : null,
        intermediates
    }
}

const getConfigTRI = (data, rsc) => {
    const extendedInfos = data?.results?.extendedInfos
    let current = findArray(extendedInfos, { ei_type: ['LEADER'], ei_code: ['CURRENT'] })
    let currentSection = current?.ei_value
    let currentLeg = current?.ei_pos
    let currentSectionPos = findArray(current.extensions, { eie_code: ['INTERMEDIATE'] })?.eie_value
    let currentPosition = 0;

    //const starters = findArray(extendedInfos, { ei_type: ['UI'], ei_code: ['STARTERS'] })?.ei_value
    //const passed = extendedInfos?.filter(item => item.ei_code === 'AFTER_INT' && item.ei_type === 'DISPLAY')?.sort((a, b) => (0 + a.pos === 'S' ? '0' : a.pos === 'F' ? '1000' : a.pos) - (0 + b.pos === 'S' ? '0' : b.pos === 'F' ? '1000' : b.pos));

    let intermediates = [];
    let index = 0;

    //If not starter node added
    if (!data?.config?.extendedConfig?.find(item => item.code === 'START' && item.pos === 'S')) {
        data?.config?.extendedConfig.push({ "type": "COURSE", "code": "START", "value": "0", "pos": "S", "extension": [{ "code": "INTERMEDIATE", "value": "Start", "pos": "S" }] })
    }

    let dataFilter = filterArray(data?.config?.extendedConfig, { type: ['COURSE'] })
    let config = dataFilter && dataFilter?.sort((a, b) => (a.pos === 'S' ? 0 : a.pos) - (b.pos === 'S' ? 0 : b.pos));

    const isMixed = getIsMixed(rsc)

    config && config?.map((configItem) => {
        let configIntermediate = filterArray(configItem?.extension, { code: ['INTERMEDIATE'] })
        let ArrayIntermediates = configIntermediate.sort((a, b) => (a.pos === 'F' ? 999 : a.pos) - (b.pos === 'F' ? 999 : b.pos));
        let leg = findArray(configItem?.extension, { code: ['LEG'] });
        let configIntermediateAll = filterArray(configItem?.extension, { code: ['INTERMEDIATE_ALL'] })
        let sw = configIntermediateAll.includes('F')
        let laps = findArray(configItem?.extension, { code: ['LAPS'] })
        //let configIntermediateAll = filterArray(configItem?.extension, { code: ['INTERMEDIATE_ALL'] })
        //let ArrayIntermediatesAll = configIntermediateAll.sort((a, b) => (a.value - b.value))


        if (Array.isArray(ArrayIntermediates)) {
            ArrayIntermediates.forEach((item, i) => {
                index = index + 1;
                if ((currentSection === configItem?.code && currentSectionPos === item?.pos && currentLeg === leg.pos) && isMixed) {
                    currentPosition = index - 1
                }
                else if (currentSection === configItem?.code && currentSectionPos === item?.pos && !isMixed) { //Individual does not have leg
                    currentPosition = index - 1
                }
                intermediates.push({
                    position: index === 1 ? 'S' : index - 1,
                    sector: {
                        code: configItem?.code,
                        pos: configItem?.pos,
                        value: configItem?.value,

                        valueIntermediate: item.value,
                        posIntermediate: item?.pos,
                        leg: {
                            pos: leg?.pos,
                            value: leg?.value
                        },
                        intermediateAll: configIntermediateAll[i]?.value,
                        lapsTotal: laps?.value ? laps?.value : '0'
                    }
                })
            })
        }
    })
    const passed = extendedInfos?.filter(item => item.ei_code === 'AFTER_INT' && item.ei_type === 'DISPLAY')?.sort((a, b) => (0 + a.pos === 'S' ? '0' : a.pos === 'F' ? '1000' : a.pos) - (0 + b.pos === 'S' ? '0' : b.pos === 'F' ? '1000' : b.pos));
    const starters = findArray(extendedInfos, { ei_type: ['UI'], ei_code: ['STARTERS'] })?.ei_value

    let finalPosition = index - 1;

    return {
        status: data?.results?.status?.code,
        currentPosition: currentPosition,
        finalPosition: finalPosition,
        starters: starters,
        passed: passed,
        intermediates
    }

}

const getConfigOWS = (data) => {
    const extendedInfos = data?.results?.extendedInfos
    // filtering extended config where @code='INTERMEDIATE'
    // sorting extended config by @pos using a trick to put 'S' on first position and 'F' on last postition
    //getting final split number. Needed to translate "F" to a number
    let finalPosition = parseInt(data?.config?.extendedConfig?.find(item => item.type === 'EC' && item.code === 'INTERMEDIATES_NUM')?.value);

    //If not starter node added
    // { "type": "EC", "code": "INTERMEDIATE", "value": "1.2", "pos": "1", "extension": [{ "code": "TYPE", "value": "SL" }] }
    if (!data?.config?.extendedConfig?.find(item => item.code === 'INTERMEDIATE' && item.pos === 'S')) {
        //finalPosition = finalPosition + 1
        data?.config?.extendedConfig.push({ "type": "EC", "code": "INTERMEDIATE", "value": "0", "pos": "S", "extension": [{ "code": "DESC", "value": "Start" }] })
    }
    const intermediates =
        data?.config?.extendedConfig?.filter(item => item.code === 'INTERMEDIATE')
            ?.sort((a, b) => (a.pos === 'S' ? 0 : a.pos === 'F' ? finalPosition : a.pos) - (b.pos === 'S' ? 0 : b.pos === 'F' ? finalPosition : b.pos));

    //competitors who have passed an intermediate point
    const passed = data?.results?.extendedInfos?.filter(item => item.ei_code === 'AFTER_INT' && item.ei_type === 'UI')?.sort((a, b) => (0 + a.pos === 'S' ? '0' : a.pos === 'F' ? '1000' : a.pos) - (0 + b.pos === 'S' ? '0' : b.pos === 'F' ? '1000' : b.pos));

    // find leader's current intermediate
    let currentPosition = findArray(extendedInfos, { ei_code: ['CURRENT_INTERMEDIATE'] })?.ei_value
    if (currentPosition === undefined && passed?.length === 0) currentPosition = 'S'


    currentPosition = currentPosition === undefined ? finalPosition : currentPosition;
    currentPosition = currentPosition === 'F' ? finalPosition : currentPosition === 'S' ? -1 : parseInt(currentPosition)

    //const passed = data?.results?.extendedInfos?.filter(item => item.ei_code === 'STAR' && item.ei_type === 'PROGRESS')?.sort((a, b) => (0 + a.pos === 'S' ? '0' : a.pos === 'F' ? '1000' : a.pos) - (0 + b.pos === 'S' ? '0' : b.pos === 'F' ? '1000' : b.pos));
    //starters
    const starters = findArray(extendedInfos, { ei_type: ['UI'], ei_code: ['STARTERS'] })?.ei_value

    //Status
    const status = data?.results?.status?.code

    return {
        currentPosition: currentPosition,
        finalPosition: finalPosition,
        intermediates: intermediates,
        passed: passed,
        starters: starters,
        status: status,
    }

}

const getConfigMPN = (data, rsc) => {
    let filters = {
        ei_type: ['DISPLAY'],
        ei_code: ['LEADER']
    };
    const extendedInfos = data?.results?.extendedInfos
    //const items = data?.results?.items
    //let rsc = RscFromStore() || "----" //No error in slice if it's undefined
    let finalPosition
    let intermediates
    let currentPosition

    if (rsc.slice(-4) === 'LR--') {  //_rsc.match("MPNMINDIVID-----------SFNL000?LR--"
        //If not starter node added
        // if (!data?.config?.extendedConfig?.find(item => item.type === 'LR' && item.code === 'INTERMEDIATE' && item.pos === 'S')) {
        //unshift: insert at firts element 
        //     data?.config?.extendedConfig.push({ "type": "LR", "code": "INTERMEDIATE", "value": "0", "pos": "S", "extension": [{ "code": "DESC", "value": "Start" }] })
        // }
        //Intermediates
        intermediates = filterArray(data?.config?.extendedConfig, { type: ['LR'], code: ['INTERMEDIATE'] });
        //intermediates.sort((a, b) => (a.pos === 'S' ? 0 : a.pos === 'F' ? finalPosition : Number(a.pos)) - (b.pos === 'S' ? 0 : b.pos === 'F' ? finalPosition : Number(b.pos)));
        intermediates && intermediates.sort((a, b) => a.pos - b.pos);

        //Final Position
        finalPosition = intermediates.length;
        // find leader's current intermediate
        currentPosition = findArray(extendedInfos, filters)?.ei_pos

        const resultStatus = data?.results?.status?.code;
        const isFinished = isFinishedStatus(resultStatus)
        currentPosition = isFinished ? finalPosition : currentPosition;

        currentPosition = currentPosition === undefined ? '-1' : currentPosition;
        //chnage S or F by position
        currentPosition = currentPosition === 'F' ? finalPosition : currentPosition === 'S' ? -1 : parseInt(currentPosition)




    }
    //not have currentPosistion case MTT CRD get from first item his current position 
    //currentPosition = currentPosition === -1 ? items?.sort((a, b) => a.sortOrder - b.sortOrder)?.find(x => x !== undefined)?.extendedResults?.find(item => item.er_type === 'ER' && item.er_code === 'CURRENT')?.er_value : currentPosition;
    //currentPosition = currentPosition === undefined ? '-1' : currentPosition;
    //return Object 
    return {
        currentPosition: currentPosition,
        finalPosition: finalPosition,
        intermediates: intermediates
    }
}

